import {httpPost} from '@/shared/api/serve/httpPost';
import {
  consumeCampaign,
  validCampaign,
} from '@/shared/lib/localStorage/campaign';

export function sendCampaign(value: string) {
  httpPost('/campaign_info', {campaign_info: value});
}
export function sendCampaignIfExists() {
  const campaign = consumeCampaign();

  if (!campaign) {
    return;
  }

  if (!validCampaign(campaign.createdAt)) {
    return;
  }

  sendCampaign(campaign.value);
}
